export default "__VITE_ASSET__qUJdJpDK__"